angular.module('impactx.autocompletegroup').directive('ixAutocompleteGroup', function () {
    return {
        scope: true,
        bindToController: {
            entryPoint: "@",
            selected: "=",
            name: "@",
            label: "@",
            readonly: "=",
            ixRequired: "=",
            showClearButton: "@",
            dialogData: "=",
            hiddenId: "="
        },
        restrict: 'E',
        controller: 'AutocompleteGroupCtrl',
        controllerAs: 'autocompleteGroupCtrl',
        templateUrl: 'shared/autocompletegroup/templates/autocomplete-group.tmpl.html'
    };
});

